import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation, useOutletContext } from 'react-router-dom';
// import { AuthContext } from '../AuthContext';
// import PDFGenerator from './ViewPdf';
import APIClient from '../common/ApiClient'
import { ToastContainer, toast } from "react-toastify";
import SearchIcon from '@mui/icons-material/Search';
import FileUploadIcon from '@mui/icons-material/FileUpload';

const Home = () => {
    const navigate = useNavigate();
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedYear, setSelectedYear] = useState('');

    const [countData, setCountData] = useState([]);
    const [tableData, setTableData] = useState(null);
    const [tableColumns, setTableColumns] = useState(null);
    const { MasterMonthChange, MasterYearChange } = useOutletContext();

    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    var currentMonth = months[new Date().getMonth()];
    var currentYear = new Date().getFullYear();
    const years = Array.from({ length: 2 }, (_, i) => currentYear - i);

    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
        MasterMonthChange(event.target.value);
    };

    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
        MasterYearChange(event.target.value);
    };
    const getData = (sMonth, sYear) => {
        APIClient.get('/getNoticeByMonth', {
            params: {
                month: sMonth,
                year: sYear,
            }
        }).then(response => {

            setTableData(response.data);
            const keys = Object.keys(response.data.length ? response.data[0] : {});
            setTableColumns(keys);
            toast.success(response.data.message, {
                position: "bottom-center",
                pauseOnHover: true,
                delay: true
            });
        }).catch(error => {
            if (error.response) {
                if (error.response.data.message) {
                    toast.error(error.response.data.message, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                } else {
                    toast.error('Failed! ' + error.response.data, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                }
            } else {
                toast.error(error.message, {
                    position: "bottom-center",
                    pauseOnHover: true
                });
            }
        });
    };
    const getDashboardCount = (sMonth, sYear) => {
        APIClient.get('/dashboardCounts', {
            params: {
                month: sMonth,
                year: sYear,
            }
        }).then(response => {

            setCountData(response.data.results);
        }).catch(error => {
            if (error.response) {
                if (error.response.data.message) {
                    toast.error(error.response.data.message, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                } else {
                    toast.error('Failed! ' + error.response.data, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                }
            } else {
                toast.error(error.message, {
                    position: "bottom-center",
                    pauseOnHover: true
                });
            }
        });
    };
    useEffect(() => {
        const sMonth = localStorage.getItem('month');
        const sYear = localStorage.getItem('year');
        if (sMonth && sMonth != "")
            currentMonth = sMonth;
        if (sYear && sYear != "")
            currentYear = sYear;

        setSelectedMonth(currentMonth);
        setSelectedYear(currentYear);
        MasterMonthChange(currentMonth);
        MasterYearChange(currentYear);
        getDashboardCount(currentMonth, currentYear);
        getData(currentMonth, currentYear);
    }, []);

    const onGoPress = (oEvent) => {
        getData(selectedMonth, selectedYear);
        getDashboardCount(selectedMonth, selectedYear);
    };
    const onItepPress = (oEvent) => {
        let id = oEvent.item['Aan No.'];
        navigate("/noticeDetails/id=" + id);
    };
    const onDashboardButtonPress = (sButtonName) => {
        switch (sButtonName) {
            case "UN":
                navigate('/upload');
        }
    };
    const onUploadPress = () => {
        navigate('/upload');
    }
    const onDashboardLinkPress = (skey) => {
        navigate("/noticeList/key=" + skey);
    }

    return <div className='childPage'>

        <div className='hBox' style={{ padding: '10px', backgroundColor: '#f4f4f4', border: 'solid 1px #e7e2e2', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex' }}>
                <select style={{ width: '100px', marginRight: '10px' }} value={selectedMonth} onChange={handleMonthChange} >
                    <option value="" disabled>Month</option>
                    {months.map((month, index) => (
                        <option key={index} value={month}>
                            {month}
                        </option>
                    ))}
                </select>
                <select style={{ width: '80px', marginRight: '10px' }} value={selectedYear} onChange={handleYearChange} >
                    <option value="" disabled>Year</option>
                    {years.map((year) => (
                        <option key={year} value={year}>
                            {year}
                        </option>
                    ))}
                </select>
                <button name='Search' onClick={(e) => { onGoPress(e.target.name) }} style={{ alignItems: 'center', display: 'flex' }}><SearchIcon style={{ width: '.6em', height: 'unset', marginRight: '5px' }}></SearchIcon>Search</button>
            </div>
            <div>
                <button name='UN' onClick={onUploadPress} style={{ alignItems: 'center', display: 'flex' }}><FileUploadIcon style={{ width: '.6em', height: 'unset', marginRight: '5px' }}></FileUploadIcon>Upload</button>
            </div>
        </div>
        <div className='cardParentCenter'>
            <div className='cardParent'>

                <div className='dashboardBox'>
                    <div className='card'>
                        <div className='card-header'>
                            <label className='labelHeading-white'>Credit Card</label>
                        </div>
                        <div className='card-body'>

                            <a name="CC" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>Total Notices - {countData && countData.length > 0 && countData[0].total_cc}</a>
                            <a name="CC-PG" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>PDF Generated - {countData && countData.length > 0 && countData[0].total_pdfGenerated}</a>
                            {/* <a name="PF" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>Pending PDF - {countData && countData.length > 0 && countData[0].total_pdfPending}</a> */}
                            <a name="CC-ES" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>Email sent - {countData && countData.length > 0 && countData[0].total_mailSent}</a>
                            {/* <a name="RR" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>Read Receipt - 0</a> */}
                            {/* <a name="PE" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>Pending Email - {countData && countData.length > 0 && countData[0].total_mailPending}</a> */}
                            <a name="CC-MS" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>WhatsApp sent - {countData && countData.length > 0 && countData[0].total_waSent}</a>
                            {/* <a name="PW" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>Pending WhatsApp - {countData && countData.length > 0 && countData[0].total_waPending}</a> */}
                            <a href="https://wa.admarksolution.com/#/wa/officalmessagehistory" target="_blank" rel="noopener noreferrer">
                                WhatsApp Report
                            </a>

                            {/* <label>Credit Card - {tableData && tableData.length}</label> */}
                        </div>
                        <div className='card-footer'>
                            {/* <button name="UN" onClick={(e) => { onDashboardButtonPress(e.target.name) }}>Upload Notice</button> */}
                        </div>
                    </div>
                </div>
                <div className='dashboardBox'>
                    <div className='card'>
                        <div className='card-header'>
                            <label className='labelHeading-white'>LRN - Credit Card</label>
                        </div>
                        <div className='card-body'>
                            <a name="LRNCC" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>Total Notices - {countData && countData.length > 0 && countData[0].total_lrncc}</a>
                            <a name="LRNCC-PG" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>PDF Generated - {countData && countData.length > 0 && countData[0].total_pdfGenerated_LRNCC}</a>
                            <a name="LRNCC-ES" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>Email sent - {countData && countData.length > 0 && countData[0].total_mailSent_LRNCC}</a>
                            <a name="LRNCC-MS" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>WhatsApp sent - {countData && countData.length > 0 && countData[0].total_waSent_LRNCC}</a>
                        </div>
                        <div className='card-footer'>
                            {/* <button name="GP">Generate PDF</button> */}
                        </div>
                    </div>
                </div>
                <div className='dashboardBox'>
                    <div className='card'>
                        <div className='card-header'>
                            <label className='labelHeading-white'>Section 25 - Credit Card</label>
                        </div>
                        <div className='card-body'>
                            <a name="SEC25CC" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>Total Notices - {countData && countData.length > 0 && countData[0].total_sec25cc}</a>
                            <a name="SEC25CC-PG" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>PDF Generated - {countData && countData.length > 0 && countData[0].total_pdfGenerated_SEC25CC}</a>
                            <a name="SEC25CC-ES" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>Email sent - {countData && countData.length > 0 && countData[0].total_mailSent_SEC25CC}</a>
                            <a name="SEC25CC-MS" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>WhatsApp sent - {countData && countData.length > 0 && countData[0].total_waSent_SEC25CC}</a>
                        </div>
                        <div className='card-footer'>
                            {/* <button name="GP">Generate PDF</button> */}
                        </div>
                    </div>
                </div>
                <div className='dashboardBox'>
                    <div className='card'>
                        <div className='card-header'>
                            <label className='labelHeading-white'>Home Loan</label>
                        </div>
                        <div className='card-body'>
                            <a name="HL" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>Home Loan - {countData && countData.length > 0 && countData[0].total_hl}</a>

                        </div>
                        <div className='card-footer'>
                            {/* <button name="SM">Send Mail</button> */}
                        </div>
                    </div>
                </div>
                <div className='dashboardBox'>
                    <div className='card'>
                        <div className='card-header'>
                            <label className='labelHeading-white'>Personal Loan</label>
                        </div>
                        <div className='card-body'>
                            <a name="PL" onClick={(e) => { onDashboardLinkPress(e.target.name) }}>Personal Loan - {countData && countData.length > 0 && countData[0].total_pl}</a>


                            {/* <Link onClick={(e) => {onDashboardLinkPress(e.target.name)}}>Messages Seen - {tableData && tableData.length}</Link> */}
                        </div>
                        <div className='card-footer'>
                            {/* <button name="SW" onClick={sendWA}>Send WhatsApp</button> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style={{ marginTop: '20px', borderRadius: '5px', border: 'solid 1px #e7e2e2', display: 'none' }}>
            {tableData && (
                <div style={{ height: '35px', alignContent: 'center' }} className='tableHeader'>
                    <label className='labelHeading'>Credit Card Notices({tableData && tableData.length})</label>
                </div>
            )}
            {tableData && tableData.length > 0 ? (
                <table>
                    <thead>
                        <tr>
                            {tableColumns.map((item, idx) => (
                                <th key={idx}>{item}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((item, idx) => (
                            <tr className='trLineItem' style={{ cursor: 'pointer' }} key={idx} data={item} onClick={(e) => { onItepPress({ item }) }}>
                                {tableColumns.map((key, idx1) => (
                                    <td data-label={key}>{item[key]}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (<div className='noDataDiv'>Notice not found for selected Month & Year!</div>)}
        </div>
        <div>
            <ToastContainer></ToastContainer>
        </div>
    </div>;

};

export default Home;
